var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('div',{staticClass:"img",class:{noimage: !_vm.src},style:(_vm.style)},[(!_vm.src)?_c('div',{staticClass:"placeholder",domProps:{"innerHTML":_vm._s(require('@/assets/icons/noimage.svg'))}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }